<template>
  <div class="flex flex-col gap-y-1.5 text-brand-black-secondary" :class="[fullWidth && '!w-full']">
    <template :key="key" v-for="(item, key) in items">
      <component
        :class="[buildElementClass(item.as)]"
        :is="item.as"
        class="flex gap-x-3 items-start"
      >
        <span
          v-if="item.as == 'li'"
          :class="{ 'bg-brand-black-secondary': !isNested }"
          class="ms-2 mt-1.5 w-1.5 h-1.5 aspect-square rounded-full border border-brand-black-secondary"
        ></span>
        {{ $t(item.text) }}
      </component>
      <TextRenderer :items="item.items" is-nested class="ps-4"></TextRenderer>
    </template>
  </div>
</template>

<script setup>
defineProps({
  isNested: Boolean,
  items: Array,
  fullWidth: Boolean
})

const buildElementClass = (as) => {
  const classMapping = {
    h1: 'text-3xl',
    h2: 'text-2xl',
    h3: 'text-xl',
    h4: 'text-lg',
    strong: 'text-base font-bold',
    span: 'text-base',
    small: 'text-sm',
    smaller: 'text-xs'
  }

  if (Object.keys(classMapping).includes(as)) {
    return classMapping[as]
  }
}
</script>

<style lang="scss" scoped></style>
